import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import PatientDialog from '../../components/dialog/PatientDialog'
import * as dialogActions from '../../redux/dialogs/actions'
import * as dialogSelectors from '../../redux/dialogs/selectors'

const PatientDialogContainer = ({
  dispatchClosePatientDialog,
  isPatientDialogOpened,
}) => {

  const handleClose = () => {
    dispatchClosePatientDialog()
  }

  return (
    <PatientDialog
      handleCloseDialog={handleClose}
      isDialogOpened={isPatientDialogOpened}
    />
  )
}

PatientDialogContainer.propTypes = {
  isPatientDialogOpened: PropTypes.bool,
  dispatchClosePatientDialog: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  isPatientDialogOpened: dialogSelectors.isPatientDialogOpened(state),
})

const mapDispatchToProps = dispatch => ({
  dispatchClosePatientDialog: () => dispatch(dialogActions.close('patient')),
})

export default connect(mapStateToProps, mapDispatchToProps)(PatientDialogContainer)
